import { render, staticRenderFns } from "./Demander1.vue?vue&type=template&id=2a23f40b&scoped=true"
import script from "./Demander1.vue?vue&type=script&lang=js"
export * from "./Demander1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a23f40b",
  null
  
)

export default component.exports